


























import Vue from "vue";
import { ref, computed } from "@vue/composition-api";
import { SharedState } from "@/common/state";
export default Vue.extend({
  props: ["items"],
  setup(props, { emit }) {
    const { getLabelDescription } = SharedState;
    const labels = computed(() => {
      // @ts-ignore
      const label = props.items.infoLabel;
      return [
        {
          ...label,
          desc: getLabelDescription(label.id),
        },
      ];
    });
    const feedbackItems = ref([
      {
        type: "iconAndText",
        id: "none",
        icon: "Question",
        name: "No feedback",
        checked: true,
      },
      {
        type: "iconAndText",
        id: "yes",
        icon: "ThumbUp",
        name: "Looks right",
        checked: false,
      },
      {
        type: "iconAndText",
        id: "no",
        icon: "ThumbDown",
        name: "Looks wrong",
        checked: false,
      },
    ]);

    const selectedItem = ref([feedbackItems.value[0]]);

    const setFeedback = (feedback: any[]) => {
      selectedItem.value = feedback;
      emit("action", feedback[0].id);
    };
    return {
      labels,
      setFeedback,
      feedbackItems,
      selectedItem,
    };
  },
});
